import React from "react";
import { Line } from 'react-chartjs-2';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import 'chart.js/auto';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const LineChartTimelinePolicies = (props) => {
  const { t } = useTranslation();
  
  // 1. DYNAMIC YEAR GENERATION
  const startYear = 1990;
  const currentYear = new Date().getFullYear();
  
  const allYears = Array.from(
    { length: currentYear - startYear + 1 }, 
    (_, i) => startYear + i
  );

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: { top: 42, right: 22, left: 22 }
    },
    scales: {
      x: {
        display: true,
        ticks: {
          callback: function(val, index) {
            const year = allYears[index];
            // Show every 5 years + current year (avoiding overlap)
            if (year === currentYear) return year;
            if (year % 5 === 0 && year < currentYear - 1) return year;
            return '';
          },
          autoSkip: false,
          maxRotation: 0,
        },
      },
      y: {
        display: true,
        title: {
          display: true,
          text: t("graphA11_ybar_label1"),
          color: "rgb(84, 84, 84)",
          font: { size: 12, weight: "500" },
          padding: { top: 30 }
        }
      }
    },
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        align: 'center',
        text: t('table_heading_est'),
        position: 'bottom',
        color: "rgb(84, 84, 84)",
        font: { size: 14, weight: "500" },
      },
      datalabels: {
        display: (context) => {
          const year = allYears[context.dataIndex];
          // Show label values only on the 5-year marks and current year
          return year === currentYear || (year % 5 === 0 && year < currentYear - 1);
        },
        align: 'end',
        anchor: 'end',
        color: "black",
        font: { size: 14, weight: "500" },
      },
    },
  };

  // 2. GENERATE SMOOTH DATA (Every year)
  const yearlyDataValues = allYears.map((year) => {
    // Cumulative count of items where year > entry value
    return props.data ? props.data.filter(elem => year > parseInt(elem.value)).length : 0;
  });

  const dataSet = {
    labels: allYears, // Every year is a label
    datasets: [
      {
        data: yearlyDataValues,
        backgroundColor: "rgb(138, 206, 126)",
        borderColor: "rgb(138, 206, 126)",
        fill: false,
        tension: 0.2, // Adds a slight curve to the line
        pointRadius: (context) => {
          const year = allYears[context.dataIndex];
          // Show points only on the labels we want to highlight
          return (year % 5 === 0 || year === currentYear) ? 1 : 0;
        }
      },
    ],
  };

  return (
    <div>
      <Card className="card-padding">
        <Card.Header className="container-header card-title">
          <p className="vertical-center">{t(props.graphTitle)}</p>
        </Card.Header>
        <Card.Body>
          {props.data && (
            <div className={props.isSubquestion ? "graph-div-subquestion" : "graph-div-main"}>
              <Line options={options} data={dataSet} className="graph-height-mobile" />
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default LineChartTimelinePolicies;